/**
 *
 * All regestered route for sidebar only.
 *
 */

import Dashboard from "views/Dashboard.js";

import InstrumentIndex from "views/Instrument/Index.js";
import Agenda from 'views/Agenda/Agenda.js';
import DocumentIndex from 'views/Helpdesk/Index.js';
import Document from 'views/Document/Document.js';
import ScopeIndex from 'views/Scope/Index.js';
import UserIndex from 'views/User/Index.js';
import AuditeeIndex from 'views/Auditee/Index.js';
import StandardIndex from 'views/Standard/Index.js';
import AuditorIndex from 'views/Auditor/Index.js';
import ScoreGroup from 'views/ScoreGroup/Index.js';
import ScoreIndex from 'views/ScoreIndex/Index.js';
import ScheduleIndex from 'views/Schedule/Index.js';
import Monitoring from 'views/Audit/Admin/Monitoring.js';

/** Only handle authenticated user */
var routes = [
  {
    path: "/dashboard",
    layout: "/admin",
    name: "Dashboard",
    icon: "nc-icon nc-chart-pie-35",
    component: Dashboard,
  },
  {
    collapse: true,
    path: "/master",
    layout: "/admin",
    name: "Master",
    icon: "nc-icon nc-chart-pie-35",
    views: [
      {
        path: "/scope",
        layout: "/admin",
        name: "Scope",
        mini: "S",
        component: ScopeIndex,
      },
      {
        path: "/auditee",
        layout: "/admin",
        name: "Auditee",
        mini: "A",
        component: AuditeeIndex,
      },
      {
        path: "/auditor",
        layout: "/admin",
        name: "Auditor",
        mini: "A",
        component: AuditorIndex,
      },
      {
        path: "/user",
        layout: "/admin",
        name: "User",
        mini: "U",
        component: UserIndex,
      },
      {
        path: "/standard",
        layout: "/admin",
        name: "Standard",
        mini: "S",
        component: StandardIndex,
      },
      {
        path: "/score",
        layout: "/admin",
        name: "Score Group",
        mini: "SG",
        component: ScoreGroup,
      },
      {
        path: "/score-index",
        layout: "/admin",
        name: "Score Index",
        mini: "SI",
        component: ScoreIndex,
      },
      // {
      //   path: "/helpdesk",
      //   layout: "/admin",
      //   name: "Document",
      //   mini: "D",
      //   component: DocumentIndex,
      // },
    ]
  },
  {
    path: "/instruments",
    layout: "/admin",
    name: "Instruments",
    state: "openComponents",
    icon: "nc-icon nc-app",
    component: InstrumentIndex,
  },
  {
    collapse: true,
    name: "Audit",
    state: "openForms",
    icon: "nc-icon nc-notes",
    views: [
      {
        path: "/schedules",
        layout: "/admin",
        name: "Schedules",
        mini: "S",
        component: ScheduleIndex,
      },
      {
        path: "/monitorings",
        layout: "/admin",
        name: "Monitoring",
        mini: "M",
        component: Monitoring,
      },
    ],
  },
  {
    path: "/agenda",
    layout: "/admin",
    name: "Agenda",
    state: "openTables",
    icon: "nc-icon nc-paper-2",
    component: Agenda,
  },
  {
    path: "/document",
    layout: "/admin",
    name: "Document",
    icon: "nc-icon nc-single-copy-04",
    component: Document,
  },
];
export default routes;
